export default String.raw`
{% comment %}
    Zwraca absolutny adres bazowy sklepu z uwzglednieniem wersji jezykowej (np. https://sklep.pl/de/).
    Do uzycia tam, gdzie potrzebny jest pelny URL z protokolem (rich snippets, udostepnianie, integracje),
    zamiast config.Url, ktory nie zawiera prefiksu jezyka i moze miec inny protokol niz strona.
    Protokol brany z page.CanonicalLink, a gdy go brak - https: (config.Url potrafi miec http: na sklepie z https).
    Do zasobow w HTML (favicon, obrazki) lepiej uzyc samego page.BaseHref (//domena/) - przegladarka wezmie protokol strony.
    Uzycie: {% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% endcomment -%}

{% assign abProtocol = 'https:' -%}
{% if page.CanonicalLink contains 'http:' -%}
    {% assign abProtocol = 'http:' -%}
{% endif -%}

{% if page.BaseHref == null or page.BaseHref == '' -%}{{ config.Url }}{% elsif page.BaseHref contains '://' -%}{{ page.BaseHref }}{% else -%}{{ abProtocol }}{{ page.BaseHref }}{% endif -%}

`